import { useQuery } from '@tanstack/react-query';
import { getAllExternalToolCategories } from '../api';
import { EXTERNAL_TOOL_CATEGORIES_QUERY_KEY } from './queryKeys';

const STALE_TIME = 5 * 60 * 1000; // 5 minutes

interface UseExternalToolCategoriesOptions {
  workspaceId?: string;
  enabled?: boolean;
}

export const useGetExternalToolCategories = (options: UseExternalToolCategoriesOptions = {}) => {
  const { workspaceId, enabled = true } = options;

  return useQuery({
    queryKey: [EXTERNAL_TOOL_CATEGORIES_QUERY_KEY, workspaceId],
    queryFn: () => getAllExternalToolCategories(workspaceId),
    staleTime: STALE_TIME,
    enabled,
  });
};
